import React from 'react';
import classes from './style.module.scss';

const GamePrice = ({
    image,
    priceList,
    priceListWeekend,
    size,
    tables,
    tableName,
    tableInfo,
}) => {
    return (
        <div className={classes.container}>
            <div>
                <div className={classes.title}>
                    <h3>{tableName}</h3>
                    <img src={image} alt="image" />
                </div>
                <p className={classes.table}>Размер стола: {size}</p>
                <p className={classes.tableInfo}>{tableInfo}</p>
                <p>Будни</p>
                <div className={classes.prices}>
                    {priceList.map((elem, index) => (
                        <div key={index} className={classes.priceItem}>
                            <p>{elem.time}</p>
                            <p>{elem.price}</p>
                        </div>
                    ))}
                </div>
                <p>Выходные и праздники</p>
                <div className={classes.prices}>
                    {priceListWeekend.map((elem, index) => (
                        <div key={index} className={classes.priceItem}>
                            <p>{elem.time}</p>
                            <p>{elem.price}</p>
                        </div>
                    ))}
                    <p>{tables}</p>
                </div>
            </div>
        </div>
    );
};

export default GamePrice;
